import React from "react";
import "./headerCardEventSlider.sass";

export default function HeaderCardEventSlider({ nameEvent, classEvent, urlEvent, sport, game_name, venue_name, podium }) {

  const removeBeforeLastDash = (str) => {
    // Encuentra el índice del último guion
    const lastDashIndex = str.lastIndexOf('-');

    // Si no hay guion, devuelve la cadena completa
    if (lastDashIndex === -1) {
      return str;
    }

    // Devuelve la parte de la cadena después del último guion
    return str.slice(lastDashIndex + 1).trim();
  };

  let cleanedString = removeBeforeLastDash(game_name);

  return (
    urlEvent ? (
      <a className={"header-card-evento-slider " + classEvent} href={urlEvent} target="_top">
        {renderContent()}
      </a>
    ) : (
      <div className={"header-card-evento-slider " + classEvent}>
        {renderContent()}
      </div>
    )
  );

  function renderContent() {
    return (
      <div className={"evento-liga"}>
        <p className={sport === "MTR" ? "name-liga-f1" : "name-liga"}>
          {sport === 'MTR' ? cleanedString : nameEvent}
        </p>
        {sport === "MTR" && podium?.length > 0 && <p className="name-direccion">{venue_name}</p>}
      </div>
    );
  }
}

